/**
 * Shared helpers for chat participant filtering and "other participant" logic.
 * Uses participant_uids only.
 */

import type { Chat } from "@fitties/shared";

/**
 * Return true if this chat is for the given user (they are a participant).
 */
export function isChatForUser(chat: Chat, userId: string): boolean {
  return chat.participant_uids?.includes(userId) ?? false;
}

/**
 * For two-party chats: return the other participant's ID, or undefined.
 * Uses participant_uids only. Returns undefined if not exactly two participants or userId not in array.
 */
export function getOtherParticipantId(chat: Chat, userId: string): string | undefined {
  const uids = chat.participant_uids;
  if (uids && uids.length === 2 && uids.includes(userId)) {
    return uids.find((id) => id !== userId);
  }
  return undefined;
}

/**
 * Derive a deterministic, collision-free chat document ID from two user IDs.
 * Sorting guarantees the same ID regardless of argument order.
 */
export function getChatIdForPair(uid1: string, uid2: string): string {
  return [uid1, uid2].sort().join("_");
}
